import constants from '../client/constants';

const difficulty = {
  [constants.QUESTION_IMPORT.DIFFICULTIES.Easy]: 'Easy',
  [constants.QUESTION_IMPORT.DIFFICULTIES.Moderate]: 'Moderate',
  [constants.QUESTION_IMPORT.DIFFICULTIES.Difficult]: 'Difficult'
};

export default function getDifficultyValueFromInt(difficultyInt, isLong = false) {
  if (difficulty[difficultyInt]) {
    return isLong ? difficulty[difficultyInt] : difficulty[difficultyInt][0];
  } else {
    return '';
  }
}
